//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';
var RECURRING_BASE_URL = '/prototype/accounting/accounts-receivable/transaction/recurring';

export default {
    data: function data() {
        return {
            loading: true,
            showWizard: false,
            currentStep: 1,
            totalSteps: 5,
            type: 'Recurring',
            repeat: '',
            repeat_day: 1,
            repeat_ends: 'Never',
            repeat_endDate: '',
            postDate: moment().format("MM/DD/YYYY"),
            nextRunDate: moment().format("MM/DD/YYYY"),
            dueDate: moment().format("MM/DD/YYYY"), //moment().add(1,'month').startOf('month').format("MM/DD/YYYY"),
            chargeType: 'charge',
            cc_category: {},
            codeSelected: { id: null, idx: null, promo_code_id: 0, recurring: 0 },
            showOverride: false,
            discountAmount: 0,
            overrideAmount: 0,
            overrideType: 'dollar',
            overrideBy: 'add',
            overrideReason: '',
            chargeCodes: [],
            categories: [],
            residents: [],
            resident: {},
            isUpdate: false,
            isUpdateRecurring: false,
            isAnApplicant: this.isapplicant,
            isResident: false,
            transaction_file_bool: false,
            transaction: null,
            saving: false,
            chargeScope: { chargeScopeType: '', chargeScopeId: 0 },
            notes: ''
        };
    },

    watch: {
        isapplicant: function isapplicant(newData, oldData) {
            this.isAnApplicant = newData;
        },
        nextRunDate: function nextRunDate(val) {
            // sync post date with next run date
            this.postDate = val;
        },
        postDate: function postDate(val) {
            // if in the future, set to recurring for one-time
            moment(val).diff(moment()) > 0 ? this.codeSelected.recurring = true : this.codeSelected.recurring = false;

            // set due date to post date - most cases it's the same
            this.dueDate = val;

            // set next run date to post date
            this.nextRunDate = val;

            // set end date to post date + one day
            this.repeat_ends = 'On Date';
            this.repeat_endDate = moment(val).add(1, 'day').format("MM/DD/YYYY");
        }
    },
    methods: {
        nextStep: function nextStep() {
            if (this.currentStep < this.totalSteps) {

                //skip recurring for one time transactions
                if (this.currentStep == 1 && this.type == 'One-Time') {
                    this.currentStep += 2;
                } else {
                    this.currentStep++;
                }
            }
        },
        previousStep: function previousStep() {
            if (this.currentStep > 1) {
                if (this.currentStep === 3 && !this.codeSelected.recurring) {
                    this.currentStep -= 2;
                } else {
                    this.currentStep--;
                }
            }
        },
        setCode: function setCode(code, idx) {
            this.codeSelected = code;
            this.codeSelected.idx = idx;
            this.codeSelected.promo_code_id = 0;
            this.codeSelected.recurring === 0 ? this.type = "One-Time" : this.type = "Recurring";
            if (this.transaction) {
                this.codeSelected.amount = this.transaction.amount;
            }
        },
        save: function save() {
            var _this = this;

            var url = null;
            this.saving = true;

            // if code is recurring AND is in the future
            // we need to create a one time transaction today
            // AND add the recurring
            if (this.codeSelected.recurring && !moment(this.postDate).isSame(moment().format("MM/DD/YYYY")) && this.type != "One-Time") {

                url = !this.isUpdateRecurring ? RECURRING_BASE_URL + '/store' : RECURRING_BASE_URL + '/update';

                // if not in the future or just a one time
                // create the transaction now
            } else {
                url = !this.isUpdate ? BASE_URL + '/store' : BASE_URL + '/update';
            }

            var data = new FormData(document.querySelector('form'));
            var self = this;

            var tempData = JSON.parse(JSON.stringify(this.$data));
            tempData.gl_account = [];
            tempData.chargeCodes = [];
            tempData.categories = [];
            tempData.resident.person = [];
            tempData.resident.unit = [];
            tempData.resident.property = [];
            tempData.resident.ledger = [];
            tempData.resident.leases = [];

            if (this.resident) {
                this.residents = null;
            }

            data.append('transaction', JSON.stringify(tempData));

            if (this.isUpdate) {
                data.append('id', this.transaction.id);
            }

            if (this.isAnApplicant || this.isapplicant) {
                data.append('is_applicant', true);
            }

            data.append('totalAmount', this.overrideAdjusted);
            data.append('overrideAdjustment', this.overrideAdjusted - this.codeSelected.amount);

            // tells us if we are resident, property or global
            data.append('chargeScope', JSON.stringify(this.chargeScope));

            axios.post(url, data).then(function (response) {
                Event.$emit('close-small-modal');
                Event.$emit('refresh-ar-transactions');
                Event.$emit('refresh-ar-recurring-transactions');
                if (self.chargeScope.chargeScopeType !== "property" && self.chargeScope.chargeScopeType !== "global") {

                    self.resident.move_out_date ? Event.$emit('refresh-past-resident-ledger-charge') : Event.$emit('refresh-resident-ledger');
                }
                _this.showWizard = false;
                _this.$snotify.success('The transaction was saved');

                if (self.isAnApplicant || self.isapplicant) {
                    Event.$emit('mark-application-paid');
                    Event.$emit('refresh-applicant-ledger', self.resident);
                    Event.$emit('load-applicant-payment-balance', self.resident);
                }

                Object.assign(_this.$data, _this.$options.data());
                _this.saving = false;
            });
        },
        revertTransaction: function revertTransaction() {
            var _this2 = this;

            var $el = this;
            $el.loading = true;

            var url = BASE_URL + '/delete';
            var data = new FormData(document.querySelector('form'));
            data.append('id', this.transaction.id);
            axios.post(url, data).then(function (response) {
                if (response.data.error) {
                    _this2.$snotify.error('Error: ' + response.data.error);
                } else {
                    _this2.$snotify.success('Renewal lease added');
                    Event.$emit('close-small-modal');
                    Event.$emit('refresh-ar-transactions');
                    Event.$emit('refresh-resident-ledger');
                    Event.$emit('refresh-past-resident-ledger');
                    Event.$emit('refresh-applicant-ledger', $el.resident);
                    Event.$emit('load-applicant-payment-balance', $el.resident);

                    _this2.showWizard = false;
                    _this2.$snotify.success('The transaction was saved');
                    $el.loading = true;
                }
            });
        },
        showGLWizard: function showGLWizard(resident, isAnApplicant, chargeScope) {
            var _this3 = this;

            var $el = this;
            //reset component
            Object.assign(this.$data, this.$options.data());

            this.chargeScope = chargeScope ? chargeScope : { chargeScopeType: '', chargeScopeId: 0 };

            // fetch charge codes and categories
            axios.post('/prototype/accounting/charge-codes/categories/list').then(function (response) {
                return _this3.categories = response.data;
            });
            axios.post('/prototype/accounting/charge-codes/list').then(function (response) {
                return _this3.chargeCodes = response.data;
            });

            // set resident if passed
            if (resident) {
                this.resident = resident;

                if ($el.isapplicant || isAnApplicant) {
                    this.isResident = false;
                    this.isAnApplicant = true;
                    this.resident.is_applicant = true;
                    this.resident.full_name = this.resident.person.full_name;
                } else {
                    this.isResident = true;
                }
            } else if (chargeScope.chargeScopeType !== 'resident') {
                // Also used to fool the "Next" button
                this.resident = { person: {} };
                this.resident.person.full_name = chargeScope.chargeScopeType === 'property' ? 'For all residents of property' : 'For all residents globally';
                this.isResident = true;
            } else {
                axios.get(BASE_URL + '/residents').then(function (response) {
                    _this3.residents = response.data;
                    _this3.residents.map(function (item) {
                        return item['full_name'] = item.person.full_name;
                    });
                });
            }

            $el.showWizard = true;
            $el.loading = false;
        },
        editGLWizard: function editGLWizard(transaction) {
            var _this4 = this;

            var recurring = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var isAnApplicant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var $el = this;
            //reset component
            Object.assign(this.$data, this.$options.data());

            // set update true
            this.isUpdate = true;

            // determines if if updates ArRecurringTransaction
            this.isUpdateRecurring = recurring;
            this.overrideAmount = transaction.override_amount;
            this.notes = transaction.notes;

            // fetch charge codes and categories
            axios.post('/prototype/accounting/charge-codes/categories/list').then(function (response) {
                return _this4.categories = response.data;
            });
            axios.post('/prototype/accounting/charge-codes/list').then(function (response) {
                return _this4.chargeCodes = response.data;
            });
            var url = recurring ? BASE_URL + '/recurring/fetch' : BASE_URL + '/fetch';
            axios.post(url, { id: transaction.id }).then(function (response) {
                // load transaction
                _this4.transaction = response.data;
                // skip recurring options
                _this4.currentStep = 4;

                // init resident since it has to be assigned already
                if ($el.isAnApplicant || $el.isapplicant || isAnApplicant) {
                    _this4.isResident = false;
                    _this4.isAnApplicant = true;
                    _this4.transaction.ledger = _this4.transaction.applicant_ledger;
                    _this4.resident = _this4.transaction.ledger.applicant;
                } else {
                    _this4.isResident = true;
                    _this4.isAnApplicant = false;
                    _this4.resident = _this4.transaction.ledger.resident;
                }

                // basic options
                _this4.postDate = moment(_this4.transaction.post_date).format('MM/DD/YYYY');
                _this4.dueDate = moment(_this4.transaction.due_at).format('MM/DD/YYYY');
                _this4.nextRunDate = moment(_this4.transaction.next_run_date).format('MM/DD/YYYY');
                if (_this4.transaction.is_credit) {
                    _this4.chargeType = 'credit';
                } else {
                    _this4.chargeType = 'charge';
                }
                // set category object
                _this4.cc_category = _this4.categories.find(function (category) {
                    return category.id === _this4.transaction.code.accounting_charge_code_category_id;
                });

                if (!_this4.cc_category) {
                    _this4.cc_category = {};
                }

                // find charge code index
                _this4.setCode(_this4.transaction.code, false);
                if (recurring) {
                    _this4.codeSelected.recurring = 1;
                }

                if (_this4.transaction.promo_code_id != 0) {
                    _this4.discountAmount = _this4.transaction.promotion_amount;
                }

                if (_this4.transaction.has_override) {
                    if (Number(_this4.transaction.true_amount) > Number(_this4.transaction.amount)) {
                        _this4.overrideAmount = Number(transaction.override_amount) - Number(transaction.amount);
                    } else {
                        _this4.overrideAmount = (Number(transaction.amount) - Number(transaction.override_amount)) * -1;
                    }
                }
                $el.loading = false;
            });
            $el.showWizard = true;
        },
        applyOverride: function applyOverride() {
            if (this.overrideAmount > 0 && this.overrideReason == '') {
                this.$snotify.error('Please provide the reason for override.');
                return;
            }
            this.showOverride = false;
        }
    },
    created: function created() {
        var _this5 = this;

        Event.$on('view-resident-details', function () {
            return Object.assign(_this5.$data, _this5.$options.data());
        });
        Event.$on('show-gl-wizard', this.showGLWizard);
        Event.$on('edit-gl-wizard', this.editGLWizard);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('show-gl-wizard');
        Event.$off('edit-gl-wizard');
    },

    computed: {
        inClosedPeriod: function inClosedPeriod() {
            if (this.transaction && this.transaction.closed_period) {
                return moment(this.transaction.post_date).isSameOrBefore(moment(this.transaction.closed_period));
            }
            return false;
        },
        discountAdjusted: function discountAdjusted() {
            var discount = this.discountAmount ? this.discountAmount : 0;
            return parseFloat(this.codeSelected.amount) - parseFloat(discount);
        },
        frequency: function frequency() {
            if (this.repeat === 'weekly') return 'Week';
            if (this.repeat === 'monthly') return 'Month';
            if (this.repeat === 'annually') return 'Year';
        },
        overrideAdjusted: function overrideAdjusted() {
            if (this.overrideBy == 'add') {
                if (this.overrideType == 'dollar') {
                    return parseFloat(this.discountAdjusted) + parseFloat(this.overrideAmount);
                }
                if (this.overrideType == 'percent') {
                    return parseFloat(this.discountAdjusted) * (1 + parseFloat(this.overrideAmount) / 100);
                }
            }
            if (this.overrideBy == 'subtract') {
                if (this.overrideType == 'dollar') {
                    return parseFloat(this.discountAdjusted) - parseFloat(this.overrideAmount);
                }
                if (this.overrideType == 'percent') {
                    return parseFloat(this.discountAdjusted) * parseFloat(this.overrideAmount) / 100;
                }
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentLedgerWizard.vue
// module id = f5hK
// module chunks = 0 1